import { Fragment } from "react";
import usePage from "../hooks/usePage";
import Menu from "../modules/public/menu/menu";
import Footer from "../modules/public/footer/footer";
import MyPacksTablePage from "../modules/pages/myAccount/account/myPackTableList";

const MyShipments = () => {
  const { pageSliders, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}
        {pageText}

        <MyPacksTablePage />
      </main>

      <Footer />
    </Fragment>
  );
};

export default MyShipments;
